import { render, staticRenderFns } from "./add.vue?vue&type=template&id=551ac4c8&scoped=true&"
import script from "./add.vue?vue&type=script&lang=ts&"
export * from "./add.vue?vue&type=script&lang=ts&"
import style0 from "./add.vue?vue&type=style&index=0&id=551ac4c8&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "551ac4c8",
  null
  
)

export default component.exports